import { ChevronLeftLineLight2 } from '@poli-digital/react';
import { Button, Card, CardBody, Icon, Label } from '@polichat/flamboyant';
import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch } from 'react-redux';
import Animation from 'src/components/common/animation';
import store from 'src/store';
import { fetchOpportunitiesAndTicketsRequest } from 'src/store/modules/chat/actions';
import {
  showBlockTwo,
  showDetailsComponent,
} from '../../../../../store/modules/chat/actions';
import { Tickets } from './TicketsDetails';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export function TicketsBox(props) {
  const contact = props.contact;
  const ticketsTitle = useGlotaT('spa.details.tickets.title');
  const errorFetchingText = useGlotaT('spa.details.errors.errorFetching');
  const tryAgainText = useGlotaT('spa.details.errors.tryAgain');
  const [cards, setCards] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  const handleTryAgain = () => {
    setCards(null);
    setLoading(true);
    setError(false);
    store.dispatch(fetchOpportunitiesAndTicketsRequest(contact, true));
  };

  useEffect(() => {
    setCards(props.cards);
    if (props.cards !== null) {
      setLoading(false);
    }
    if (props.cards === undefined) {
      setError(true);
    }
    return ()=>{
      setLoading(true);
    }
  }, [props.cards]);

  useEffect(() => {
    if (props.cards === null) {
      setLoading(true);
      store.dispatch(fetchOpportunitiesAndTicketsRequest(contact, true));
    }
    return ()=>{
      setLoading(true);
    }
  }, [props.contact.id, props.isOpen]);

  return (
    <div className="moreInfosTickets">
      <div className="title" onClick={props.toggleTickets}>
        <ChevronLeftLineLight2 />
        <span>
          <strong>{ticketsTitle}</strong>
        </span>
        <div className="closeDetails">
          <Button
            color="link"
            onClick={() => {
              isMobile && dispatch(showBlockTwo());
              dispatch(showDetailsComponent(false));
            }}
          >
            <Icon icon="poli-icon pi-close-fill" />
          </Button>
        </div>
      </div>
      <Card className="infoItemsContainer">
        <CardBody className="infoItems">
          {loading ? (
            <Animation icon="loading" top={'50%'} />
          ) : error ? (
            <>
              <Label>{errorFetchingText}</Label>
              <Button onClick={handleTryAgain}>{tryAgainText}</Button>{' '}
            </>
          ) : (
            <Tickets isOpen={props.isOpen} toggleTickets={props.toggleTickets} openEmbedModal={props.openEmbedModal} tickets={cards?.tickets?.data} />
          )}
        </CardBody>
      </Card>
    </div>
  );
}
